import { render, staticRenderFns } from "./RuleDetails.vue?vue&type=template&id=1764e97c&scoped=true&"
import script from "./RuleDetails.vue?vue&type=script&lang=js&"
export * from "./RuleDetails.vue?vue&type=script&lang=js&"
import style0 from "./RuleDetails.vue?vue&type=style&index=0&id=1764e97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1764e97c",
  null
  
)

export default component.exports